export default [
  "$uibModal",
  "InvestActivityRestService",
  function ($modal, InvestActivityRestService) {
    return {
      openDescription,
      openEdit,
      api: InvestActivityRestService,
    };

    function openDescription(id, municipalities) {
      return $modal.open({
        template: require("../view/invest-activity-description-form.html"),
        controller: "InvestActivityControllerDescriptionForm",
        controllerAs: "vm",
        size: "w1200",
        backdrop: false,
        resolve: {
          id: () => id,
          municipalities: () => municipalities
        },
      });
    }

    function openEdit(data, activeYear) {
      return $modal.open({
        template: require("../view/invest-activity-edit-form.html"),
        controller: "InvestActivityControllerEditForm",
        controllerAs: "vm",
        size: "w1200",
        backdrop: false,
        resolve: { data: () => data, activeYear: () => activeYear > 0 ? activeYear : new Date().getFullYear() },
      });
    }
  },
];
